import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { GameDayModel } from '../../models/gameday-model';
import { MonitorBasePageService } from './monitor-base-page.service';
import { GameDayRootReducerState } from '../../state/root.state';
import { BarChartLegend } from '../../shared/models/charts/chart-data-types';

const MONITOR_PRIORITY_RETAIL_CATEGORY: BarChartLegend = {
  id: 'Priority Retail',
  name: 'Priority Retail',
  value: undefined,
  color: undefined,
  selected: undefined
};
const MONITOR_PRIORITY_NON_RETAIL_CATEGORY: BarChartLegend = {
  id: 'Priority Non-Retail',
  name: 'Priority Non-Retail',
  value: undefined,
  color: undefined,
  selected: undefined
};
const MONITOR_PRIORITY_CATEGORIES_LIST: BarChartLegend[] = [
  MONITOR_PRIORITY_RETAIL_CATEGORY,
  MONITOR_PRIORITY_NON_RETAIL_CATEGORY
];

@Injectable()
export class MonitorPriorityPageService extends MonitorBasePageService {
  constructor(store: Store<GameDayRootReducerState>) {
    super(store);
  }

  public extractCategories(
    _deal: GameDayModel.Deal,
    _orders: GameDayModel.Order[]
  ): BarChartLegend[] {
    return MONITOR_PRIORITY_CATEGORIES_LIST;
  }

  public getCategoriesNames(
    categoriesMap: Map<string, BarChartLegend>,
    order: GameDayModel.Order,
    _deal: GameDayModel.Deal
  ): string[] {
    const id = order.retailInd
      ? MONITOR_PRIORITY_RETAIL_CATEGORY.id
      : MONITOR_PRIORITY_NON_RETAIL_CATEGORY.id;

    return [categoriesMap.get(id).name];
  }
}
